import { Suspense, useState } from 'react'
import { ScrollView, View } from 'react-native'
import Animated from 'react-native-reanimated'

import { ErrorBoundary } from '@/src/config/sentry'
import { DonationBanner } from '@/src/features/donation/ui/components/DonationBanner'
import { useDonationBannerAnimation } from '@/src/features/donation/ui/hooks/useDonationBannerAnimation'
import { TEST_ID } from '@/src/general/constants/testId'

import type { TDonationBannerProps } from './DonationBanner/DonationBanner.types'

type TAnimatedDonationBannerProps = TPickyPartial<TDonationBannerProps, 'donationData'> & {
  showDonationBanner: boolean
}

export const AnimatedDonationBanner = ({
  showDonationBanner,
  donationData,
  ...otherProps
}: TAnimatedDonationBannerProps) => {
  // Mount the banner only once it has been shown, then keep it mounted so the mobile modal can animate its closing.
  const [hasBeenShown, setHasBeenShown] = useState(showDonationBanner)
  if (showDonationBanner && !hasBeenShown) setHasBeenShown(true)
  const { animatedHeightY, animatedY, onLayout } = useDonationBannerAnimation(showDonationBanner && !!donationData)

  return (
    <View className="relative z-10">
      <Animated.View testID={TEST_ID.DONATION.PLACEHOLDER} style={[{ width: '100%' }, animatedHeightY]} />
      <Animated.View
        role="status"
        style={[{ maxWidth: '100%', position: 'absolute', width: '100%', zIndex: 10 }, animatedY]}
        onLayout={onLayout}
      >
        <ScrollView className="py-2 min-w-full px-4 max-h-screen">
          {hasBeenShown && !!donationData && (
            <View className="py-2">
              <Suspense>
                <ErrorBoundary>
                  <DonationBanner showDonationBanner={showDonationBanner} donationData={donationData} {...otherProps} />
                </ErrorBoundary>
              </Suspense>
            </View>
          )}
        </ScrollView>
      </Animated.View>
    </View>
  )
}
